export default __webpack_public_path__ + "static/media/herosTr.ac095578.svg";